import React, { useEffect, useState } from "react";
import { Card, PageHeader, StatusPill, Empty, Btn } from "../../components/dash/Kit";
import { api } from "../../lib/api";

const filters = ["", "upcoming", "active", "expired", "urgent"];
const labels = { "": "All", upcoming: "Upcoming", active: "Active", expired: "Expired", urgent: "Urgent" };

export default function AdminPromotions() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("date");

  useEffect(() => {
    api
      .get("/admin/promotions", { params: filter ? { filter } : {} })
      .then((r) => setRows(r.data))
      .catch(() => {});
  }, [filter]);

  const sorted = [...rows].sort((a, b) => {
    if (sort === "customer") return (a.customer?.business_name || "").localeCompare(b.customer?.business_name || "");
    if (sort === "priority") return (b.urgency === "Time Sensitive") - (a.urgency === "Time Sensitive");
    return (b.start_date || "").localeCompare(a.start_date || "");
  });

  return (
    <div className="space-y-6" data-testid="admin-promotions-page">
      <PageHeader title="Promotions" body="Every promotion submitted by customers." />

      <Card testId="admin-promotions-filters">
        <div className="flex flex-wrap gap-2">
          {filters.map((f) => (
            <Btn
              key={f || "all"}
              variant={filter === f ? "dark" : "outline"}
              testId={`promo-filter-${f || "all"}`}
              onClick={() => setFilter(f)}
            >
              {labels[f]}
            </Btn>
          ))}
          <span className="mx-2 h-9 w-px bg-slate-200" aria-hidden="true" />
          {["date", "customer", "priority"].map((s) => (
            <Btn key={s} variant={sort === s ? "primary" : "outline"} testId={`promo-sort-${s}`} onClick={() => setSort(s)}>
              Sort: {s}
            </Btn>
          ))}
        </div>
      </Card>

      {sorted.length === 0 ? (
        <Empty testId="admin-promotions-empty" title="No promotions" />
      ) : (
        <div className="space-y-3" data-testid="admin-promotions-list">
          {sorted.map((p) => (
            <Card key={p.id} testId={`admin-promotion-${p.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-display text-base font-semibold text-slate-900">{p.name}</p>
                  <p className="text-xs text-slate-500">{p.customer?.business_name} · {p.customer?.email}</p>
                  <p className="mt-2 text-sm text-slate-600">{p.description}</p>
                  <p className="mt-2 text-xs text-slate-500">
                    {p.start_date || "—"} → {p.end_date || "open"}
                    {p.price ? ` · ${p.price}` : ""}{p.discount ? ` · ${p.discount}` : ""}
                    {p.promo_code ? ` · code ${p.promo_code}` : ""}
                  </p>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <StatusPill status={p.window} />
                  {p.urgency === "Time Sensitive" && (
                    <span className="rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700">Urgent</span>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
